import { useSelector } from 'react-redux';

import { ElevatorDetail } from '../types';
import { selectElevator } from '../services/selectors';

export default (): ElevatorDetail => useSelector(selectElevator);
